// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getProductRealTimeInventory } from "@guestsupply/App/Services/ProductServiceV2";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { ProductInventoryDto, WarehouseDto } from "@insite/client-framework/Types/ApiModels";

interface Result {
    errorMessage: string;
    warehouses?: WarehouseDto[];
}

type HandlerType = Handler<
    GetProductRealTimeInventoryApiV2Parameter & {
        /** This is a legacy onComplete, it will only fire if the Handler CallOnComplete is hit */
        onComplete: (result: Result) => void;
        unitOfMeasure: string;
    },
    {
        apiParameter: GetProductRealTimeInventoryApiV2Parameter;
        apiResult?: ProductInventoryDto;
        result: Result;
    }
>;
// XNG-CHANGES-GSS-480 : pass performRealTimeInventory property and update getProductRealTimeInventory import
export const XngRequestDataFromApi: HandlerType = async props => {
    const state = props.getState();
    const isCartPage = getCurrentPage(state).type === "CartPage";
    const { isGuest } = state.context.session;
    const performRealTimeInventory = isGuest || isCartPage;

    props.apiResult = await getProductRealTimeInventory({
        ...props.apiParameter,
        properties: {
            performRealTimeInventory,
        },
    });
};

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);
